import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Alert,
    Row,
    Col,
    FormFeedback,
    FormText
} from 'reactstrap';
import { updateOilById } from './redux/dispatcher';
import { Link } from 'react-router-dom';

function UpdateViewOil({ args, isViewOnly, data, setIsUpdate, setIsViewOnly, searchQuery, selectedOil }) {
    const dispatch = useDispatch();
    const companyListData = useSelector((state) => state.companyListReducer);
    const [loginUserType, setLoginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role)

    const [companyName, setCompanyName] = useState(data?.company_id);
    const [companyList, setCompanyList] = useState(companyListData?.data?.data || []);

    const [modal, setModal] = useState(true);
    const [status, setStatus] = useState(data?.status == 'active');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [oilType, setOilType] = useState(data?.oil_type);
    const [brand, setBrand] = useState(data?.brand_name);
    const [brandList, setBrandList] = useState(['Brand A', 'Brand B', 'Brand C']);
    const [packingSize, setPackingSize] = useState(data?.product_name);
    const [packingSizeList, setPackingSizeList] = useState(['Brand A', 'Brand B', 'Brand C']);
    const [price, setprice] = useState(data?.price)
    const [ri, setRi] = useState(data?.ri || '')
    const [pdfFile, setPdfFile] = useState(data?.msds_file_path)
    const [msdsFile, setMsdsFile] = useState('');
    const [TestPdfFile, setTestPdfFile] = useState(data?.test_cert_file_path)
    const [testFile, setTestFile] = useState('');
    const [formError, setFormError] = useState({
        brandName: false,
        price: false,
        packingSize: false,
        oiltype: false,
        selectedCompany: false,
        ri: false
    })
    // Handle Modal (Show or not)
    const toggleModal = () => {
        setModal(!modal);
        setError('');
        setLoading(false);
        setCompanyName('')
        setStatus(true);
        setOilType('')
        setBrand('')
        setPackingSize('')
        setRi('')
        setErrorMessage('')
        setIsUpdate(false);
        setIsViewOnly(false);
        setFormError({
            brandName: false,
            price: false,
            packingSize: false,
            oiltype: false,
            selectedCompany: false,
            ri: false
        })
    };

    const handleStatusChange = () => setStatus(!status);

    const handleLinkClick = (e) => {
        console.log('pdf file', pdfFile)

        e.preventDefault();
        window.open(pdfFile, '_blank', 'noopener,noreferrer');
    };

    const handleTestLinkClick = (e) => {
        console.log('test file', TestPdfFile)
        e.preventDefault();
        window.open(TestPdfFile, '_blank', 'noopener,noreferrer');
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            setMsdsFile(file);
            setErrorMessage('');
        } else {
            setMsdsFile(null);
            // setErrorMessage('Please select a valid PDF file.');
            toast.error('Please select a valid PDF file.')
        }
    };

    const handleTestFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            setTestFile(file);
            setErrorMessage('');
        } else {
            setTestFile(null);
            // setErrorMessage('Please select a valid PDF file.');
            toast.error('Please select a valid PDF file.')
        }
    };
    // Handle Form
    const handleFormSubmit = async () => {
        if (!oilType || !brand || !packingSize || !price || !companyName) {
            setFormError(
                {
                    brandName: formError.brandName || !brand,
                    price: formError.price || !price,
                    packingSize: formError.packingSize || !packingSize,
                    oiltype: formError.oiltype || !oilType,
                    selectedCompany: !companyName
                }
            );
            setErrorMessage('Please correct the errors in the form.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            const formData = new FormData();
            formData.append('price', price);
            formData.append('product_name', packingSize);
            formData.append('status', status ? 'active' : 'inactive');
            formData.append('company_id', companyName);
            formData.append('type', oilType);
            formData.append('brand_name', brand);
            formData.append('id', data?.oil_id);

            // Add RI if it has a value
            if (ri !== '' && ri !== null && ri !== undefined) {
                const roundedRI = parseFloat(ri).toFixed(2);
                formData.append('ri', roundedRI);
            }

            //Conditionally append the file if it exits 
            if (msdsFile) {
                formData.append('msds_file', msdsFile);
            }

            if (testFile) {
                formData.append('test_cert_file', testFile);
            }
            console.log('form data is', companyName)
            dispatch(updateOilById(formData, toggleModal, searchQuery, selectedOil === 'ot' ? null : selectedOil));
        } catch (err) {
            toast.error('Error adding machine. Please try again.');
        } finally {
            setLoading(false);
            toggleModal();
        }
    };

    //Regex for validation 
    const validateBrandName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, brandName: false }));
            return;
        }
        // const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,20}$/;
        const regex = /^.{2,20}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, brandName: !isValid }));
    };

    //Regex for validation 
    const validatePrice = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, price: false }));
            return;
        }
        const regex = /^\d{1,10}(\.\d{1,})?$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, price: !isValid }));
    };

    //Regex for validation 
    const validatePackingSize = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, packingSize: false }));
            return;
        }
        // const regex = /^\d{1,10}(\.\d{1,})?$/;
        const regex = /^.{2,20}$/;

        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, packingSize: !isValid }));
    };

    //RI validation and formatting
    const handleRiChange = (e) => {
        let { value } = e.target;
        // Allow only digits and one dot
        value = value.replace(/[^0-9.]/g, '');
        const parts = value.split('.');
        if (parts.length > 2) {
            // More than one dot, remove extras
            value = parts[0] + '.' + parts.slice(1).join('');
        }
        const [intPart, decPart] = value.split('.');
        if (decPart && decPart.length > 2) {
            value = intPart + '.' + decPart.slice(0, 2);
        }
        setRi(value);
        setFormError(prevState => ({ ...prevState, ri: false }));
    };

    const handleRiBlur = () => {
        const raw = ri;
        if (raw === '' || raw === null || raw === undefined) {
            setFormError(prevState => ({ ...prevState, ri: false }));
            return;
        }
        const num = parseFloat(raw);
        if (!isNaN(num) && num > 0) {
            setRi(num.toFixed(2));
            setFormError(prevState => ({ ...prevState, ri: false }));
        } else {
            setFormError(prevState => ({ ...prevState, ri: true }));
        }
    };

    return (
        <div>
            <Button color="primary" onClick={toggleModal}>
                Add Oil
            </Button>

            <Modal isOpen={modal} toggle={toggleModal} {...args} modal style={{ maxWidth: '40%' }}>
                <h1 style={{ textAlign: 'center', borderBottom: '4px solid #135674', color: '#135674' }} className=" m-3">
                    {
                        isViewOnly ? 'View Oil' : 'Update Oil'
                    }
                </h1>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="oilTypeSelect">Select Type<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="oiltype"
                                        id="oilTypeSelect"
                                        value={oilType}
                                        onChange={(e) => {
                                            setOilType(e.target.value)
                                            setFormError(prevState => ({ ...prevState, oiltype: false }));
                                        }}
                                        invalid={formError.oiltype}
                                        disabled
                                    >
                                        <option value="">Select Type</option>
                                        <option value="Coolant">Coolant Oil</option>
                                        <option value="Maintenance">Maintenance Oil</option>
                                        <option value="Hydraulic">Hydraulic Oil</option>
                                    </Input>
                                    <FormFeedback>Please select oil type.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="brandSelect">Brand Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="text"
                                        name="brand"
                                        id="brandSelect"
                                        value={brand}
                                        placeholder='Enter brand name'
                                        invalid={formError.brandName}
                                        onChange={(e) => {
                                            setBrand(e.target.value)
                                            validateBrandName(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={20}
                                    />
                                    <FormFeedback>BrandName must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="packingsize">Product Name<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="text"
                                        name="packingsize"
                                        id="packingsize"
                                        value={packingSize}
                                        placeholder='Enter Product Name'
                                        invalid={formError.packingSize}
                                        onChange={(e) => {
                                            setPackingSize(e.target.value)
                                            validatePackingSize(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Enter valid Product Name.</FormFeedback>
                                </FormGroup>
                            </Col>
                            {oilType === 'Coolant' && (
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="ri">RI</Label>
                                        <Input
                                            type="text"
                                            name="ri"
                                            id="ri"
                                            value={ri}
                                            placeholder="Enter RI"
                                            invalid={formError.ri}
                                            onChange={handleRiChange}
                                            onBlur={handleRiBlur}
                                            disabled={isViewOnly}
                                        />
                                        <FormFeedback>RI must be a positive number with at most 2 decimal places.</FormFeedback>
                                    </FormGroup>
                                </Col>
                            )}
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="companySelect">Select Company<span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="selectCompany"
                                        id="companySelect"
                                        value={companyName}
                                        onChange={(e) => {
                                            setCompanyName(e.target.value)
                                            setFormError(prevState => ({ ...prevState, selectedCompany: false }));
                                        }}
                                        invalid={formError.selectedCompany}
                                        disabled
                                    >
                                        <option value="">Select company*</option>
                                        {companyList.map((item) => (
                                            <option key={item?.id} value={item?.id}>
                                                {item?.company_name}
                                            </option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Please select company.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="price">Price<span style={{ color: 'red' }}>*</span> (per Liter)</Label>
                                    <Input
                                        type="text"
                                        name="price"
                                        id="price"
                                        value={price}
                                        placeholder='Enter price'
                                        invalid={formError.price}
                                        onChange={(e) => {
                                            setprice(e.target.value)
                                            validatePrice(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Price must be a number or a decimal.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>



                        {/* <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="companySelect">Select Company*</Label>
                                    <Input
                                        type="select"
                                        name="selectCompany"
                                        id="companySelect"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        disabled={isViewOnly}
                                    >
                                        <option value="">Select company*</option>
                                        {companyList.map((item) => (
                                            <option key={item?.id} value={item?.id}>
                                                {item?.company_name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                {
                                    isViewOnly ? '' :

                                        <FormGroup className="mr-3" >
                                            <Label
                                                for="upload"
                                                style={{ borderBottom: '2px solid grey' }}
                                            >
                                                Attach MSD File in PDF
                                            </Label>
                                            <Input
                                                type="file"
                                                id="upload"
                                                accept="application/pdf"
                                                onChange={handleFileChange}
                                                hidden
                                            />
                                            <Label
                                                for="upload"
                                                className="btn btn-primary ml-2"
                                            // style={{ cursor: 'pointer', minWidth: '140px' }}
                                            >
                                                <i class="fa-solid fa-upload"></i>
                                            </Label>
                                            {msdsFile && (
                                                <Link to="#" onClick={handleLinkClick}>
                                                    <FormText color="primary">Attached File</FormText>
                                                </Link>
                                            )}
                                        </FormGroup>
                                }
                            </Col>
                        </Row> */}



                        <Row>

                            <Col md={6}>
                                <FormGroup>
                                    {
                                        isViewOnly ? <Label for="upload" >
                                            Test Certificate
                                        </Label> :
                                            <>
                                                <Label for="upload" style={{
                                                    // color: '#135674',
                                                    cursor: 'pointer',
                                                    marginTop: '8px',
                                                    borderBottom: '2px solid grey',
                                                    display: 'inline-block' // This ensures the border only spans the text width
                                                }}>
                                                    Attach Test Certificate
                                                </Label>
                                                <Input
                                                    type="file"
                                                    id="upload"
                                                    accept="application/pdf"
                                                    onChange={handleTestFileChange}
                                                    hidden
                                                    disabled={isViewOnly}
                                                />
                                                <Label
                                                    for="upload"
                                                    className="btn btn-primary ml-2"
                                                // style={{ cursor: 'pointer', minWidth: '140px' }}
                                                >
                                                    <i className="fa-solid fa-upload"></i>
                                                </Label>
                                                {/* <Label
                                                    for="upload"
                                                    className="btn btn-primary ml-2"
                                                // style={{ cursor: 'pointer', minWidth: '140px' }}
                                                >
                                                    <i className="fa-solid fa-upload"></i>
                                                </Label> */}
                                            </>
                                    }
                                    {testFile && (
                                        <FormText color="muted">{testFile.name}</FormText>
                                    )}
                                    {!testFile && TestPdfFile && (
                                        <div>
                                            <h5
                                                style={{
                                                    color: '#135674',
                                                    cursor: 'pointer',
                                                    marginTop: '8px',
                                                    borderBottom: '2px solid grey',
                                                    display: 'inline-block' // This ensures the border only spans the text width
                                                }}
                                                onClick={(e) => handleTestLinkClick(e)}
                                            >
                                                Download File
                                            </h5>
                                        </div>

                                    )}

                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    {
                                        isViewOnly ? <Label for="uploadmsds" >
                                            MSDS File
                                        </Label> :
                                            <>
                                                <Label for="uploadmsds" style={{
                                                    // color: '#135674',
                                                    cursor: 'pointer',
                                                    marginTop: '8px',
                                                    borderBottom: '2px solid grey',
                                                    display: 'inline-block' // This ensures the border only spans the text width
                                                }}>
                                                    Attach MSDS File in PDF
                                                </Label>
                                                <Input
                                                    type="file"
                                                    id="uploadmsds"
                                                    accept="application/pdf"
                                                    onChange={handleFileChange}
                                                    hidden
                                                    disabled={isViewOnly}
                                                />
                                                <Label
                                                    for="uploadmsds"
                                                    className="btn btn-primary ml-2"
                                                // style={{ cursor: 'pointer', minWidth: '140px' }}
                                                >
                                                    <i className="fa-solid fa-upload"></i>
                                                </Label>
                                                {/* <Label
                        for="upload"
                        className="btn btn-primary ml-2"
                    // style={{ cursor: 'pointer', minWidth: '140px' }}
                    >
                        <i className="fa-solid fa-upload"></i>
                    </Label> */}
                                            </>
                                    }
                                    {msdsFile && (
                                        <FormText color="muted">{msdsFile.name}</FormText>
                                    )}
                                    {!msdsFile && pdfFile && (
                                        <div>
                                            <h5
                                                style={{
                                                    color: '#135674',
                                                    cursor: 'pointer',
                                                    marginTop: '8px',
                                                    borderBottom: '2px solid #135674',
                                                    display: 'inline-block' // This ensures the border only spans the text width
                                                }}
                                                onClick={(e) => handleLinkClick(e)}
                                            >
                                                Download File
                                            </h5>
                                        </div>

                                    )}

                                </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup className='d-flex'>
                                    <Label for="statusSelect" className='mr-4'>Status</Label>
                                    <CustomInput
                                        type="switch"
                                        id="statusSelect"
                                        name="status"
                                        label={status ? 'Active' : 'Inactive'}
                                        checked={status}
                                        onChange={handleStatusChange}
                                        disabled={isViewOnly}
                                    />
                                </FormGroup>

                            </Col>
                            <Col md={6}>
                            </Col>
                        </Row>


                    </Form>
                </ModalBody>
                <ModalFooter>
                    {
                        isViewOnly ? '' :

                            <Button color="primary" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? <Spinner size="sm" /> : 'Update Oil'}
                            </Button>
                    }
                    <Button color="secondary" onClick={toggleModal} style={isViewOnly ? { outline: 'none', boxShadow: 'none', backgroundColor: '#135674', color: 'white' } : {}}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default UpdateViewOil;
